import { date as formatDate, money } from "../../../utils/format";

export function TripProgram({ view, selectedDate }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Programme technique</h3>
        {selectedDate ? (
          <span className="card-sub">
            Départ du {formatDate(selectedDate.startDate)}
          </span>
        ) : null}
      </div>
      <div className="card-body" style={{ display: "grid", gap: 12 }}>
        {view.steps.map((step, index) => {
          const stepDate = selectedDate?.stepDates?.[index];
          const isScheduled = Boolean(stepDate);
          return (
          <div key={step.id} className="card" style={{ display: "grid", gridTemplateColumns: "180px 1fr", gap: 16, padding: 16, opacity: isScheduled ? 1 : 0.55 }}>
            <div>
              <span className="badge primary">Étape {step.rank}</span>
              <div className="muted" style={{ fontSize: 11.5, marginTop: 6 }}>
                {isScheduled ? formatDate(stepDate) : "Non planifié"}
              </div>
              <div className="strong" style={{ marginTop: 8 }}>{step.city}</div>
              <div className="muted" style={{ fontSize: 12 }}>{step.country}</div>
              <div style={{ marginTop: 10 }}>
                <div className="k">Hébergement</div>
                <div className="v" style={{ fontSize: 13 }}>{step.hosting.name}</div>
                <div style={{ color: "var(--warning)", fontSize: 12 }}>{"★".repeat(step.hosting.stars)}</div>
              </div>
            </div>

            <div>
              <p style={{ margin: "0 0 10px", fontSize: 13.5, color: "var(--text-2)" }}>{step.description}</p>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <div>
                  <div className="k" style={{ marginBottom: 6 }}>Inclusions</div>
                  {step.activities.map((a) => (
                    <div key={a.id} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "4px 0" }}>
                      <span>{a.title}</span>
                      <span className="strong">{a.isIncluded ? "Inclus" : money(a.price)}</span>
                    </div>
                  ))}
                </div>
                <div>
                  <div className="k" style={{ marginBottom: 6 }}>Options</div>
                  {step.options.map((o) => (
                    <div key={o.id} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "4px 0" }}>
                      <span>{o.title}</span>
                      <span className="strong">{money(o.price)}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          );
        })}
      </div>
    </div>
  );
}

export default TripProgram;
